import React from 'react';

import Select from 'react-select';

import capSurveyStatusV1 from '@/data/capSurveyStatusV1';
import capSurveyStatusV2 from '@/data/capSurveyStatusV2';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectCAPSurveyStatusV1: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled, version }) => {
    return (
        <Select
            name={name}
            value={version === '0' ? capSurveyStatusV1.find((option: any) => option.value === value) : capSurveyStatusV2.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={version === '0' ? capSurveyStatusV1 : capSurveyStatusV2}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectCAPSurveyStatusV1;
